import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React from "react";
import { NavLink } from "react-router-dom";
import * as commonUtil from "../../../../utils/commonUtil";
import LimitedCharReactQuill from "../../../shared2/reactQuills/LimitedCharReactQuill";
import LimitedCharTextField from "../../../shared2/LimitedCharTextField";
import "./style.css";

import ReactQuill from "react-quill";
import AuthContext from "../../../../AuthContext";
import mtzApis from "../../../../services";
const { companyService } = mtzApis;

export default function CompanyDescriptionViewEdit({ companyId, profileName }) {
  let [company, setCompany] = React.useState(null);
  let [open, setOpen] = React.useState(new URLSearchParams(window.location.search).get('selectedDialog') === 'COMPANY_DETAILS' ? true : false);
  let [changes, setChanges] = React.useState({});

  const me = React.useContext(AuthContext);

  React.useEffect(() => {
    (async () => {
      let currCompany;
      if (companyId) {
        const companies = await companyService.getCompanies(
          new URLSearchParams(`companyIds=${companyId}`)
        );
        currCompany = companies.length > 0 ? companies[0] : null;
      }

      if (!currCompany)
        if (profileName) {
          const companies = await companyService.getCompanies(
            new URLSearchParams(`profileName=${profileName}`)
          );
          currCompany = companies.length > 0 ? companies[0] : null;
        }

      setCompany(currCompany);
      commonUtil.updateOutboundLinks();
    })();
  }, [companyId, profileName]);

  const updateCompany = async () => {
    mtzApis.startSpinningIcon();
    let updated = await companyService.updateCompanyById(company.id, changes);
    mtzApis.stopSpinningIcon();
    setOpen(false);
    setCompany(updated);
  };

  return (
    <Card className="company-basic-info" elevation={0}>
      {me && company && me.userId === company.ownerId ? (
        <CardHeader
          action={
            <div>
              <button className="btn btn-sm btn-link"
                onClick={() => setOpen(true)}>
                <span className="fa fa-edit"></span> Edit description
              </button>
              <Dialog fullWidth maxWidth="sm" open={open || false} onClose={() => setOpen(false)}>
                <DialogTitle id="form-dialog-basic-info" className="text-center" disableTypography>
                  <h4 className="company-edit-dialog-header">Editing description</h4>
                </DialogTitle>

                <DialogContent>
                  <div>
                    <div className="my-4">
                      <LimitedCharTextField
                        required={true}
                        onChange={(event) =>
                          setChanges({ ...changes, summary: event.target.value })
                        }
                        value={company.summary || ""}
                        label="Company summary: Max 100 Characters"
                        rows={3}
                        attribute="summary"
                        limit={100}
                        className="w-100"
                        variant="outlined"
                      />
                    </div>

                    <div className="my-4">
                      {/* <label htmlFor="description">Description: Max 1000 Characters</label> */}
                      <LimitedCharReactQuill
                        limit={1000}
                        onChange={(event) =>
                          setChanges({
                            ...changes,
                            description: event.target.value,
                          })
                        }
                        className="w-100"
                        value={company.description || ""}
                        label={"Description: Max 1000 Characters"}
                      />
                    </div>
                  </div>
                </DialogContent>

                <DialogActions>
                  <Button
                    className="close-button"
                    onClick={() => setOpen(false)}
                    variant="outlined"
                    color="primary"
                    disableElevation
                  >
                    <span className="close-button-text">Close</span>
                  </Button>
                  <Button
                    className="save-button"
                    variant="contained"
                    color="primary"
                    disableElevation
                    onClick={() => updateCompany()}
                  >
                    <span className="save-button-text">Save</span>
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          }
          subheader={
            <h5 className="company-description-text">
              <NavLink to="#" onClick={() => setOpen(true)}>
                Description
              </NavLink>
            </h5>
          }
        />
      ) : (
        <CardHeader subheader={<h5 className="company-description-text">Description</h5>} />
      )}

      <CardContent className="py-1">
        <div className="alert alert-secondary">
          <b>Overview:</b> {company && company.summary}
        </div>

        <ReactQuill
          value={company && company.description}
          readOnly
          theme='bubble'
        />
      </CardContent>
    </Card>
  );
}
